import React from 'react'

import './styles.scss'
import { UserAvatar } from 'components/common'
import TimeAndDate from 'utils/TimeAndDate'
import { lang } from 'utils/helpers'
import { getAutomationIcon, getAutomationNameTag } from 'utils/AutomationActivity'

const TYPE_NAVIGATION = ['assign', 'message', 'nautaError']

const NotificationCard = (props) => {
  const { notification, markAsRead, openConversation } = props

  const {
    type, isRead, actionOperator, user, content, _id, createdAt,
    insertBy
  } = notification

  const { time, unit } = TimeAndDate.timeSince(createdAt)

  const legend = () => {
    switch (type) {
      case 'mention':
        return <p>{lang('dash_notification_mention')}</p>
      case 'assign':
      case 'unassign': {
        let name = `${actionOperator.name || ''} ${actionOperator.lastname || ''}`.trim()
        if (!name) name = actionOperator.email || ''
        if (!name && insertBy) {
          const title = getAutomationNameTag(insertBy)
          if (title) name = lang(title)
        }
        const translation = type === 'assign' ? 'dash_notification_assign' : 'dash_notification_unassign'

        return <p><strong>{name}</strong> {lang(translation)} <strong>{user.name}</strong></p>
      }
      case 'smartchat':
        return <p dangerouslySetInnerHTML={{ __html: lang('dashboard_va-finished-training') }} />
      case 'export':
        return <p>{lang('dash_notification_export')} <a href={content} target='_blank' rel="noopener noreferrer"><strong onClick={() => markAsRead(_id, true)} className='underline'>{lang('dashboard_link')}</strong></a></p>
      case 'exportError':
        return <p>{lang('dash_notification_export_error')}</p>
      case 'message': {// only work for penedes
        let name = `${actionOperator?.name || ''} ${actionOperator?.lastname || ''}`.trim()
        if (!name) name = actionOperator.email

        const text = name ? 'dash_notification_message_operator' : 'dash_notification_message'

        return (
          <p>{name ? (<strong>{name} </strong>) : null}{lang(text)} <strong>{user.name}</strong></p>
        )
      }
      case 'endMassiveAction':
        return (
          <p
            dangerouslySetInnerHTML={{
              __html: lang('dashboard_mass-action-completed-name', { name: lang(`dashboard_${content.replaceAll('_', '-')}`) })
            }}
          />
        )
      case 'exportSearchCSV':
        return (
          <p
            dangerouslySetInnerHTML={{
              __html: lang('dashboard_conversation-export-complete-download-link', { link: content })
            }}
          />
        )
      case 'nautaError':
        return <p
          dangerouslySetInnerHTML={{
            __html: lang('dash_notification_nauta_error', { name: user.name })
          }}
        />
      default:
        return ''
    }
  }

  let avatarUrl = actionOperator.picture || ''
  if (!avatarUrl && insertBy) {
    avatarUrl = getAutomationIcon(insertBy)
  }

  return (
    <div className={`notification-card-container ${type === 'message' ? 'notification-color-message' : ''}`} style={{ opacity: isRead? 0.5: 1 }}>
      <div
        className={`avatar-and-legend ${TYPE_NAVIGATION.includes(type) && 'selected-click'}`}
        onClick={
          TYPE_NAVIGATION.includes(type)
            ? () => {
              markAsRead(_id, true)
              openConversation(user)
            }
            : null
        }
      >
        <UserAvatar avatar={avatarUrl || ''} avatarHeight={33} avatarWidth={33} />
        {legend()}
      </div>
      <div
        className='container_point'
        onClick={()=> markAsRead(_id, !isRead)}
      >
        <div
          className={`indicator ${isRead && 'indicatorRead'}`}
        />
        <p>{`${time} ${lang(unit)}`}</p>
      </div>
    </div>
  )
}

export default NotificationCard